import { render, staticRenderFns } from "./bjazgy.vue?vue&type=template&id=400ea73c&scoped=true&"
import script from "./bjazgy.vue?vue&type=script&lang=js&"
export * from "./bjazgy.vue?vue&type=script&lang=js&"
import style0 from "./bjazgy.vue?vue&type=style&index=0&id=400ea73c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400ea73c",
  null
  
)

export default component.exports